module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7GBQD"))).then(() => parcelRequire('hEqeo'));